import { VStack } from "@gluestack-ui/themed";
import { Icon } from "@repo/core/components/core/Icon";
import { Text } from "@repo/core/components/core/Text";
import { ConfirmCardPasswordProps } from "./types";
import { InputOTP } from "@repo/core/components/core/InputOTP";
import { useDebounceCallback } from "usehooks-ts";
import { useState } from "react";

export const ConfirmCardPassword = ({
  handleConfirmCardPassword,
  pt = "$24"
}: ConfirmCardPasswordProps) => {
  const [cardPassword, setCardPassword] = useState("");

  const onChange = (value: string) => {
    if (value.length === 4) {
      handleConfirmCardPassword(value);
    }
    setCardPassword(value);
  };

  const debouncedOnChange = useDebounceCallback(onChange, 1000);

  return (
    <VStack alignItems="center" pt={pt}>
      <VStack mb="$4">
        <Icon name="lock" size={40} color="$primary600" />
      </VStack>
      <Text mb="$6" fontSize="$lg" fontWeight={600} color="$textLight900">
        Senha
      </Text>
      <VStack
        maxWidth={230}
        mb="$10"
        alignItems="center"
        justifyContent="center"
      >
        <Text
          fontSize="$sm"
          fontWeight={400}
          color="$textLight900"
          textAlign="center"
        >
          Digite a senha do cartão:
        </Text>
      </VStack>
      <InputOTP
        value={cardPassword}
        name="cardPassword"
        onChange={debouncedOnChange}
        isRequired
        placeholder="••••"
        inputType="password"
      />
    </VStack>
  );
};
